<template>
  <div>
    <NotificationMessage class="notification" />
    <div class="layout" v-if="center">
      <div class="mb-5">
        <div class="text-h5 mb-2">
          {{ center.name }}
        </div>
        <div>
          <EditCenterDialogButton
            :center="centerCopy"
            @click="copyCenter"
            color="red darken-1"
            dark
          >
            <template #dialog-button-text>
              {{ $t("crudCenter.updateCenter") }}
            </template>
          </EditCenterDialogButton>
          <v-btn color="red darken-1 ml-2" dark @click="changeStyle">
            Style
          </v-btn>
        </div>
      </div>

      <div class="mb-5 rooms" ref="griddiv">
        <RoomsList
          class="rooms-list"
          :center="center"
          :rooms="rooms"
          :planRef="$refs.roomsPlan"
        />
        <PlanCanvas
          class="ml-3"
          ref="roomsPlan"
          :shapes="rooms"
          :config="planConfig"
          canvasWidth="1500"
          canvasHeight="600"
          :editMode="editMode"
        />
      </div>
    </div>
  </div>
</template>

<script>
import NotificationMessage from "@/components/components-base/notification/NotificationMessage";
import EditCenterDialogButton from "@/components/components-salles/admin/crud/center/EditCenterDialogButton";
import RoomsList from "@/components/components-salles/admin/details/center/RoomsList";
import PlanCanvas from "@/components/components-salles/common/PlanCanvas";
import PlanAdminConfig from "@/models/plan/AdminConfig.json";
import PlanUserConfig from "@/models/plan/UserConfig.json";
import { mapActions, mapGetters } from "vuex";

export default {
  name: "CenterDetailsView",
  components: {
    NotificationMessage,
    EditCenterDialogButton,
    RoomsList,
    PlanCanvas,
  },
  data: () => ({
    planConfigs: [PlanAdminConfig, PlanUserConfig],
    planConfigIndex: 0,
    centerCopy: null,
    editMode: true,
  }),
  computed: {
    ...mapGetters("centerModule", { centerById: "getCenterById" }),
    ...mapGetters("roomModule", { roomsByCenterId: "getRoomsByCenterId" }),

    center() {
      return this.centerById(parseInt(this.$route.params.centerId));
    },
    rooms() {
      return this.roomsByCenterId(this.center.id);
    },
    planConfig() {
      return this.planConfigs[this.planConfigIndex];
    },
  },
  methods: {
    ...mapActions("centerModule", ["loadCentersWithDependents"]),
    ...mapActions("roomModule", ["loadRoomsWithDependents"]),

    changeStyle() {
      this.editMode = !this.editMode;
      this.$refs.roomsPlan.resetCursor();

      ++this.planConfigIndex;
      if (this.planConfigIndex >= this.planConfigs.length)
        this.planConfigIndex = 0;
      this.$refs.roomsPlan.drawImage = this.planConfigIndex == 0;
      this.$refs.roomsPlan.requestCanvasFrame();
    },
    copyCenter() {
      this.centerCopy = structuredClone(this.center);
    },
  },
  async mounted() {
    await this.loadCentersWithDependents();
    await this.loadRoomsWithDependents();
  },
};
</script>

<style lang="scss" scoped>
.notification {
  position: absolute;
  padding: 0 1.5rem;
  z-index: 100;
}

.layout {
  margin: 0 1rem;
  display: flex;
  flex-direction: column;
  justify-content: center;
}

.rooms {
  display: flex;
  flex-direction: row;
}

.rooms-list {
  min-width: 300px;
}
</style>
